@if (price) {
  <span [ngClass]="{'opacity-75': !showroomMode}">
    @if (((showLabel || showroomMode) && !hideLabel && !kioskMode)) {
      {{ 'RETAIL_PRICE' | translate }}
    }
    <span [innerHTML]="price.value |  currencyConvert: price.currency"></span>
  </span>
}
